import React, { useEffect } from 'react';
import './advantage.css';
// import Aos from "aos";
// import "aos/dist/aos.css";

function Advantage() {

    //     useEffect(() => {
    //     Aos.init({
    //       offset: 0,
    //       duration: 800,
    //       once: true,
    //     });

    //     // Refresh after DOM fully painted
    //     setTimeout(() => {
    //       Aos.refreshHard();
    //     }, 100);

    //   }, []);

    return (
        <section className="investment adv" id='benefits'>
            <div className="container-lg">
                <h2 className='d-block d-lg-none' data-aos="fade-up" data-aos-delay="0">Privileges with your ICICI Bank Salary Account</h2>
                <div className="row g-md-5 justify-content-center">
                    <div className="col-md-6 col-xxl-5">
                        <img src="dist/img/advantage.webp" width={741} height={497} alt="One Account" className='img-fluid adv-img' />
                    </div>
                    <div className="col-md-6 col-xxl-5">
                        <h2 className='d-none d-lg-block' data-aos="fade-up" data-aos-delay="0">Privileges with your ICICI Bank Salary Account</h2>
                        <div className="row mt-3 adv_wrap">
                            <div className="col-12" data-aos="fade-up" data-aos-delay="600" >
                                <img src="dist/img/icons/investment.svg" alt="Secure your future" width={40} height={40} />
                                <p>Investment <br /> planning for life.</p>
                            </div>
                            <div className="col-12" data-aos="fade-up" data-aos-delay="1000" >
                                <img src="dist/img/icons/laptop-mobile.svg" alt="Extend account benefits" width={40} height={40} />
                                <p>Offers on  Apple products</p>
                            </div>



                            <div className="col-12" data-aos="fade-up" data-aos-delay="1200" >
                                <img src="dist/img/icons/cashback.svg" alt="Amazon Pay ICICI Bank Credit Card" width={40} height={40} />
                                <p>Get Amazon Pay ICICI Bank Credit Card and <br className='desktop-none' /> earn up to 5%* cashback using it on Amazon</p>
                            </div>
                            <div className="col-12" data-aos="fade-up" data-aos-delay="800" >
                                <img src="dist/img/icons/atm.svg" alt="Instant Auto and Personal Loans" width={40} height={40} />
                                <p>Unlimited ATM <br /> transactions</p>
                            </div>
                            <div className="col-12" data-aos="fade-up" data-aos-delay="1200" >
                                <img src="dist/img/icons/family.svg" alt="Amazon Pay ICICI Bank Credit Card" width={40} height={40} />
                                <p>Extend account benefits to your family  <br className='desktop-none' /> with complimentary personal & air accidental insurance<sup>#</sup></p>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
}

export default Advantage;
